import { createElement, memo } from '@max/max';
import Image from '@hfe/max-image';
import View from '@hfe/max-view';
import Sensor from '@max/mbc-sensor';
import Price from '@max/leez-price';
import Text from '@hfe/max-text';
import LinearGradient from '@hfe/max-linear-gradient';
import './index.scss';
import { CARD_MC, CARD_MV, POS_ICON } from '../../utils/constant';
import { formatDiscount, formatPrice, getLocString } from '../../utils/utils';
import { venusParams } from '../../utils/formatImage';
// import { navigateTo } from '@max/meituan-uni-navigate';
import { IS_MT_WEB } from '../../utils/constant';
import navigateToPage from '../../utils/jump';
const MyComponent = (props) => {
    const { dealText, index, _LXReport, menuId, item } = props;
    const { mvReport, mcReportWithTag } = _LXReport;
    function handleBuy() {
        mcReportWithTag && mcReportWithTag(CARD_MC, {
            valLab: {
                deal_id: item === null || item === void 0 ? void 0 : item.dealId,
                instance_id: menuId,
                item_index: index
            }
        });
        navigateToPage(item === null || item === void 0 ? void 0 : item.dealJumpLink);
    }
    const tagStyle = {
        marginTop: IS_MT_WEB ? '-6rpx' : '0rpx',
        paddingTop: IS_MT_WEB ? '2rpx' : '0rpx'
    };
    return <Sensor 
    // once={true}
    onAppear={() => {
            mvReport && mvReport(CARD_MV, {
                valLab: {
                    deal_id: item === null || item === void 0 ? void 0 : item.dealId,
                    instance_id: menuId,
                    item_index: index
                }
            });
        }}>
      <View className="horizontal-card-container" onClick={handleBuy}>
        <View className="horizontal-card-image-view">
          <Image className="horizontal-card-image" source={{
            uri: venusParams(item === null || item === void 0 ? void 0 : item.frontImg, 290, 218)
        }}/>
          <LinearGradient className="horizontal-card-image-shadow" start={{
            x: 0,
            y: 0
        }} end={{
            x: 0,
            y: 1
        }} colors={['rgba(0,0,0,0.00)', '#000000']}/>
          <View className="horizontal-card-pos">
            <Image className="horizontal-card-pos-icon" source={{
            uri: POS_ICON
        }}/>
            <Text className="horizontal-card-pos-text">{getLocString(item === null || item === void 0 ? void 0 : item.dealLocateInfo)}</Text>
          </View>
        </View>
        <Text className="horizontal-card-deal-title" numberOfLines={2}>
          {item === null || item === void 0 ? void 0 : item.dealName}
        </Text>
        <View className="horizontal-card-tag-field" style={tagStyle}>
          {!!(item === null || item === void 0 ? void 0 : item.discountRate) && (item === null || item === void 0 ? void 0 : item.discountRate) !== '0.0' && (item === null || item === void 0 ? void 0 : item.discountRate) !== '10.0' && <View className="horizontal-card-discount-tag">
              <Text className="horizontal-card-discount-text">{formatDiscount(item === null || item === void 0 ? void 0 : item.discountRate)} 折</Text>
            </View>}
          {(item === null || item === void 0 ? void 0 : item.dealSaleTags) && (item === null || item === void 0 ? void 0 : item.dealSaleTags.length) > 0 && (() => {
            var _a;
            const tagItem = item.dealSaleTags[0];
            return (tagItem === null || tagItem === void 0 ? void 0 : tagItem.tagType) === 2 ? <View className="horizontal-card-sale-tag" style={{
                    backgroundColor: tagItem === null || tagItem === void 0 ? void 0 : tagItem.backgroundColor
                }}>
                  <Text className="horizontal-card-sale-text" style={{
                    color: tagItem === null || tagItem === void 0 ? void 0 : tagItem.color
                }}>
                    {tagItem === null || tagItem === void 0 ? void 0 : tagItem.title}
                  </Text>
                </View> : <Image className="horizontal-card-sale-tag-image" style={{
                    width: (tagItem === null || tagItem === void 0 ? void 0 : tagItem.title) ? ((_a = tagItem === null || tagItem === void 0 ? void 0 : tagItem.title) === null || _a === void 0 ? void 0 : _a.length) * 15 : 60
                }} resizeMode="contain" source={{
                    uri: tagItem === null || tagItem === void 0 ? void 0 : tagItem.icon
                }}/>;
        })()}
        </View>
        <View className="horizontal-card-bottom-field">
          <View className="horizontal-card-price-field">
            <View className="horizontal-card-price">
              <Price type="l8" priceStyle={{
            fontSize: '32rpx'
        }} fontWeightType={'bold'} content={formatPrice(item === null || item === void 0 ? void 0 : item.price)}/>
              <Text className="horizontal-card-price-start" style={{
            marginBottom: IS_MT_WEB ? '8rpx' : '12rpx'
        }}>
                起
              </Text>
            </View>
            {!!(item === null || item === void 0 ? void 0 : item.originalPrice) && (item === null || item === void 0 ? void 0 : item.price) !== (item === null || item === void 0 ? void 0 : item.originalPrice) && <Price style={{
                marginTop: IS_MT_WEB ? '-17rpx' : '-5rpx'
            }} type="l4" crossed={true} content={formatPrice(item === null || item === void 0 ? void 0 : item.originalPrice)} fontWeightType={'regular'} priceStyle={{
                fontSize: '20rpx',
                lineHeight: '22rpx'
            }} symbolStyle={{
                fontSize: '20rpx',
                lineHeight: '22rpx'
            }}/>}
          </View>
          <View>
            <LinearGradient className="horizontal-card-btn" start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 1
        }} colors={['#FF7700', '#FF4B10']} style={{
            marginTop: IS_MT_WEB ? '20rpx' : '0rpx'
        }}>
              <Text className="horizontal-card-btn-text">{dealText}</Text>
            </LinearGradient>
          </View>
        </View>
      </View>
    </Sensor>;
};
export default memo(MyComponent);
